/**
 * @generated SignedSource<<9b6679726e39588423e5663390e0d8b8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiDesignGenEditor_Query$variables = Record<PropertyKey, never>;
export type aiDesignGenEditor_Query$data = {
  readonly designWithAIPresets: ReadonlyArray<{
    readonly description: string | null;
    readonly id: string;
    readonly isActive: boolean;
    readonly name: string;
    readonly presetID: number;
  }>;
  readonly designWithAISetting: {
    readonly customPrompt: string | null;
    readonly id: string;
    readonly presetID: number | null;
    readonly settingsID: number;
    readonly useAIDesignCreatorMode: boolean;
  } | null;
};
export type aiDesignGenEditor_Query = {
  response: aiDesignGenEditor_Query$data;
  variables: aiDesignGenEditor_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presetID",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DesignWithAISettingDTO",
    "kind": "LinkedField",
    "name": "designWithAISetting",
    "plural": false,
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "settingsID",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customPrompt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "useAIDesignCreatorMode",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DesignWithAIPresetInfoDTO",
    "kind": "LinkedField",
    "name": "designWithAIPresets",
    "plural": true,
    "selections": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiDesignGenEditor_Query",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiDesignGenEditor_Query",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "73dcb9bbdffb45fdbe554b7969db7a63",
    "id": null,
    "metadata": {},
    "name": "aiDesignGenEditor_Query",
    "operationKind": "query",
    "text": "query aiDesignGenEditor_Query {\n  designWithAISetting {\n    id\n    settingsID\n    presetID\n    customPrompt\n    useAIDesignCreatorMode\n  }\n  designWithAIPresets {\n    id\n    presetID\n    name\n    description\n    isActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "8fda266c94a64efeb2c6546deb9ba1bd";

export default node;
